import { AttendanceSubmissionResponseTypes } from "backend/src/features/attendance_submission/attendance_submission.controller";
import { Requests } from "../common/request.common";
import { get, post, postEmpty } from "./common";

export const attendanceSubmission = {
    record(data: typeof Requests.AttendanceSubmission.Record.Input) {
        return post<typeof data, AttendanceSubmissionResponseTypes.Record>(
            "/attendance-submission/record",
            data,
        );
    },
    obtain(id: string) {
        return get<AttendanceSubmissionResponseTypes.Obtain>(`/attendance-submission/obtain/${id}`);
    },
    approve(id: string) {
        return postEmpty<AttendanceSubmissionResponseTypes.Approve>(
            `/attendance-submission/approve/${id}`,
        );
    },
    reject(id: string) {
        return postEmpty<AttendanceSubmissionResponseTypes.Reject>(
            `/attendance-submission/reject/${id}`,
        );
    },
};
